export enum DashboardPanelType {
  PROFILE_QUESTIONS,
  LIVEPOLL_QUESTIONS,
  LEADERBOARD
}
